import './App.css';
// import React from 'react';
import Microlink from '@microlink/react';

const articles = [
  {
    section: 'Equity, Sustainability and Future Readiness',
    items: [
      {
        title: 'Oceans of Inequity: How Technology May Divide the Last Commons',
        source: 'Times of India Blogs',
        date: '20 April 2025',
        link: 'https://timesofindia.indiatimes.com/blogs/voices/oceans-of-inequity-how-technology-may-divide-the-last-commons/',
        summary:
          'Analyses how AI, autonomous mapping, and data networks may stratify access to ocean resources, converting global commons into technologically gated domains. Argues for equitable governance frameworks that protect access rights, data sovereignty, and benefit-sharing.',
      },
      {
        title: 'Wake Up India: AI Colonialism Is Not a Myth',
        source: 'Moneycontrol Opinion',
        date: '6 March 2025',
        link: 'https://www.moneycontrol.com/news/opinion/wake-up-india-ai-colonialism-is-not-a-myth-12958134.html',
        summary:
          'Warns that India’s dependence on imported AI chips, cloud platforms, and large language models risks a new dependency—“AI colonialism.” Argues for sovereign digital infrastructure as central to democratic autonomy, equitable growth, and strategic resilience.',
      },
    ],
  },
  {
    section: 'Climate Governance & Environmental Limits',
    items: [
      {
        title: 'Climate Negotiations: A Process That Fails, Yet Cannot Be Abandoned',
        source: 'Times of India Blogs',
        date: '20 May 2025',
        link: 'https://timesofindia.indiatimes.com/blogs/voices/climate-negotiations-a-process-that-fails-yet-cannot-be-abandoned/',
        summary:
          'A realistic assessment of the global climate negotiation regime—acknowledging persistent weaknesses but defending multilateralism as indispensable for common rules, accountability pressures, and shared responsibility.',
      },
      {
        title: 'World Plastic Crisis: Awareness and Circular Economy Can Save the Day',
        source: 'Firstpost',
        date: 'April 2025',
        link: 'https://www.firstpost.com/opinion/world-plastic-crisis-awareness-and-circular-economy-can-save-the-day-13879800.html',
        summary:
          'Traces the lifecycle failure of plastics—from convenience to persistence and toxicity—and argues that circular economy strategies must be backed by producer responsibility, segregation infrastructure, and equity-centric policy.',
      },
    ],
  },
  {
    section: 'Air Pollution as a Governance & Infrastructure Failure',
    items: [
      {
        title: 'Clean Air: India’s Missing Infrastructure',
        source: 'Times of India Blogs',
        date: '23 October 2025',
        link: 'https://timesofindia.indiatimes.com/blogs/voices/clean-air-indias-missing-infrastructure/',
        summary:
          'Reframes air pollution as a system and infrastructure deficit rather than a behavioural problem, arguing for engineered monitoring, enforcement mechanisms, and accountable institutions.',
      },
      {
        title: 'Delhi’s Air: The Myths That Keep Choking Us',
        source: 'News18 Opinion',
        date: '28 October 2025',
        link: 'https://www.news18.com/opinion/opinion-delhis-air-the-myths-that-keep-choking-us-ws-kl-9665926.html',
        summary:
          'Identifies persistent misconceptions—such as cloud seeding as a panacea or seasonal inevitability—that distract from system-level action grounded in science and governance reform.',
      },
      {
        title:
          'Cloud Seeding: Between Hope, Humility and the Limits of Control (with C.K. Mishra)',
        source: 'News18 Opinion',
        date: '3 November 2025',
        link: 'https://www.news18.com/opinion/opinion-cloud-seeding-between-hope-humility-and-the-limits-of-control-ws-kl-9677008.html',
        summary:
          'Provides a balanced assessment of cloud seeding, acknowledging its potential while stressing scientific, operational, and governance limits without broader emissions reduction.',
      },
      {
        title: 'Cleaning Delhi’s Air Requires a Delhi-Specific Plan',
        source: 'Indian Express Opinion',
        date: '18 December 2025',
        link: 'https://indianexpress.com/article/opinion/columns/cleaning-delhis-air-requires-a-delhi-specific-plan-10427736/',
        summary:
          'Advocates governance tailored to Delhi’s meteorology and airshed realities, favouring predictive planning and regional coordination over generic national frameworks.',
      },
    ],
  },
  {
    section: 'January 2026 — The Air Pollution Trilogy (Exposure > Optics)',
    items: [
      {
        title:
          'Work From Home Is No Shield Against Toxic Air — Unless Indoor Discipline Is Followed',
        source: 'News18 Opinion',
        date: '3 January 2026',
        link: 'https://www.news18.com/opinion/opinion-work-from-home-is-no-shield-against-toxic-air-unless-indoor-discipline-is-followed-ws-l-9807470.html',
        summary:
          'Challenges the assumption that indoor work automatically reduces exposure, explaining how infiltration, poor ventilation, and indoor sources sustain pollution levels and proposing a public-health framework for indoor air discipline.',
      },
      {
        title: 'Dealing With Delhi’s Invisible Smog Trap',
        source: 'Hindustan Times Opinion',
        date: '21 January 2026',
        link: 'https://www.hindustantimes.com/opinion/dealing-with-delhi-s-invisible-smog-trap-101768922924408.html',
        summary:
          'Explains how early gains in pollution control give way to a more insidious phase dominated by secondary pollutants and fine fractions, requiring deeper chemical and institutional understanding.',
      },
      {
        title:
          'Blindspots in Air Pollution Management: Why Cleaner-Looking Air Is Not Necessarily Healthier Air',
        source: 'Times of India Blogs',
        date: 'January 2026',
        link: 'https://timesofindia.indiatimes.com/blogs/voices/blindspots-in-air-pollution-management-why-cleaner-looking-air-is-not-necessarily-healthier-air/',
        summary:
          'Exposes regulatory blindspots such as over-reliance on PM₂.₅ averages and visual air quality indices, arguing for governance focused on toxicity, precursor dynamics, and health outcomes.',
      },
    ],
  },
];

function Art() {
  return (
    <div className="App">
      <main className="App-maina">
        <header>
          <h2>Dr Arun Kumar Mehta — Selected Articles (2025–2026)</h2>
          <p className="intro">
            A curated compendium of essays that diagnose structural failures in
            governance, environmental infrastructure, equity, and technology
            policy—shaped by long experience in public administration and
            systemic reform.
          </p>
        </header>

       {articles.map((group) => (
  <section key={group.section} className="article-section">
    <h3>{group.section}</h3>

    <ul className="article-list">
      {group.items.map((item) => (
        <li key={item.title} className="article-item">
          <article>
            <h4>{item.title}</h4>

            <p className="meta">
              {item.source} · {item.date}
            </p>

            <p>{item.summary}</p>

            <Microlink
              url={item.link}
            //   size="large"
            //   media="image"
            //   description={false}
              lazy
            //   target="_blank"
            //   rel="noopener noreferrer"
            //   className="microlink-card"
            />
          </article>
        </li>
      ))}
    </ul>
  </section>
))}
      </main>
    </div>
  );
}

export default Art;
